var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "drugSearchComponent" }, [
    _c("div", { staticClass: "flex drug_select_block" }, [
      _c(
        "div",
        { staticClass: "maxWidth" },
        [
          _c(
            "v-select",
            {
              ref: "select",
              attrs: {
                label: "title",
                placeholder: "Препарат",
                filterable: false,
                options: _vm.drugList,
              },
              on: { input: _vm.selectDrug, search: _vm.searchDrug },
              nativeOn: {
                keypress: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    $event.preventDefault()
                  },
                  function ($event) {
                    return _vm.fastSearchCheck.apply(null, arguments)
                  },
                ],
              },
              scopedSlots: _vm._u([
                {
                  key: "option",
                  fn: function (option) {
                    return [
                      _c(
                        "div",
                        { staticClass: "d-center" },
                        [
                          option && option.title
                            ? [
                                _vm._v(
                                  "\n              " +
                                    _vm._s((option && option.title) || "") +
                                    "\n              " +
                                    _vm._s(
                                      _vm.showDetails !== false &&
                                        option.veshchestvo
                                        ? "::" + option.veshchestvo
                                        : ""
                                    ) +
                                    "\n            "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ]
                  },
                },
                {
                  key: "selected-option",
                  fn: function (option) {
                    return [
                      option && option.title
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(option.title || "") +
                                "\n            " +
                                _vm._s(
                                  _vm.showDetails !== false &&
                                    option.veshchestvo
                                    ? ":: " + option.veshchestvo
                                    : ""
                                ) +
                                "\n            " +
                                _vm._s(
                                  _vm.showId && option.id
                                    ? "(" + option.id + ")"
                                    : ""
                                ) +
                                "\n          "
                            ),
                          ]
                        : _vm._e(),
                    ]
                  },
                },
              ]),
              model: {
                value: _vm.drug,
                callback: function ($$v) {
                  _vm.drug = $$v
                },
                expression: "drug",
              },
            },
            [
              _c("template", { slot: "no-options" }, [
                _vm._v("\n          введите название препарата..\n        "),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.enableQty
        ? _c("div", { staticClass: "flex" }, [
            _vm.drug
              ? _c("div", { staticClass: "wd-70" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.drug.qty,
                        expression: "drug.qty",
                      },
                    ],
                    staticClass: "form-control border-r-0 h-100",
                    attrs: {
                      placeholder: "Количество",
                      type: "number",
                      name: "qty",
                    },
                    domProps: { value: _vm.drug.qty },
                    on: {
                      change: _vm.updateDrug,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.drug, "qty", $event.target.value)
                      },
                    },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.drug && _vm.drug.holod
              ? _c("div", { staticClass: "cool_mark" }, [
                  _c("i", { staticClass: "icon icon-snowflake" }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.drug
              ? _c(
                  "div",
                  [
                    _c(
                      "v-popover",
                      { attrs: { "auto-hide": true } },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-info btn-xs border-r-0 sm-btn",
                            staticStyle: { height: "38px" },
                            on: {
                              click: function ($event) {
                                return _vm.getDrugInfo(_vm.drug.id, true)
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "icon-fa icon-fa-info icon-info",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "template",
                          { slot: "popover" },
                          [
                            _vm.localDrugData && _vm.localDrugData.info
                              ? [
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.printDrugInfo(
                                          _vm.localDrugData.info
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              : [
                                  _vm._v(
                                    "\n              Загрузка ....\n            "
                                  ),
                                ],
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                directives: [
                                  {
                                    name: "close-popover",
                                    rawName: "v-close-popover",
                                  },
                                ],
                                staticClass: "btn btn-theme btn-sm",
                              },
                              [_vm._v("Закрыть")]
                            ),
                          ],
                          2
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }